import { ArticlePublisher } from '@/cmsComponents/ArticlePublisher';
import CmsImage from '@/cmsComponents/CmsImage';
import { PATH } from 'constants/path';
import Link from 'next/link';
import React from 'react';
import { IArticleSummary } from 'types/cms';

import Typography from '@material-ui/core/Typography';

import { defaultAlt } from 'components/Image';

import styles from './ArticleItemTop.module.scss';

interface IProps {
  article: IArticleSummary;
}

const ArticleItemTop: React.FC<IProps> = ({ article }) => (
  <article>
    <div className={styles.box}>
      <Link
        href={`${PATH.ARTICLES}/${article.slug}`}
        as={`${PATH.ARTICLES}/${article.slug}`}
        passHref
      >
        <a className={styles.link}>
          <div className={styles.cover}>
            {article.cover ? (
              <CmsImage
                altText={article.cover.alternativeText || defaultAlt}
                imageProps={article.cover}
                format="small"
                layout="fill"
              />
            ) : (
              <p className={styles.cover__error}>Failed to load image...</p>
            )}
            <div className={styles.topLeft}>{article.article_category?.name}</div>
          </div>
          <div className={styles.titleH2}>
            <Typography variant="h6" component="h2">
              {article.title}
            </Typography>
          </div>
          <div className={styles.blurb}>{article.blurb}</div>
          <ArticlePublisher author={article.author} publishedDate={article.published_date} />
        </a>
      </Link>
    </div>
  </article>
);

export default ArticleItemTop;
